import React from 'react'

const ClosingStockReport = () => {
  return (
    <div className='mx-auto p-4'>
      <h4 className='font-semibold text-[#192252]'>New</h4>
      
      <div className="bg-white p-4 rounded-lg my-4">

      </div>
    </div>
  )
}

export default ClosingStockReport
